// The three Xano group bases, in their own module because of an import cycle:
// xano.ts calls the generated client, and the generated client imports
// request() and these bases from xano.ts. Declared in xano.ts itself, a base
// would be read by xanoClient.generated.ts before xano.ts had set it (bundlers
// turn the const into a var, so it reads undefined rather than throwing).
// xano.ts imports this module before the generated one and re-exports all three.

export const AUTH_BASE = import.meta.env.VITE_XANO_AUTH_URL as string;
export const CMS_BASE = import.meta.env.VITE_XANO_CMS_URL as string;

/**
 * Bloxx Audit group (canonical WdlocAgw). Public, unauthenticated, and the same
 * engine the MCP connector and the public checker use, which is the point: the
 * admin app must not be able to show a site a score nobody else can reproduce.
 *
 * Hardcoded rather than proxied through the Vite dev proxy like the other two,
 * because it takes no token and sends no user data, so there is nothing to hide
 * behind a same-origin path.
 */
export const AUDIT_BASE =
  (import.meta.env.VITE_XANO_AUDIT_URL as string | undefined) ||
  "https://xyfa-9qn6-4vhk.n7.xano.io/api:WdlocAgw";

if (!AUTH_BASE || !CMS_BASE) {
  // Surfaces during development if env wasn't loaded.
  // eslint-disable-next-line no-console
  console.error(
    "Missing VITE_XANO_AUTH_URL or VITE_XANO_CMS_URL. Copy .env.example to .env.local."
  );
}
